import { RouteGroup } from '@/modules/core/app/constants/api.constants';
import { BaseEntityResource } from '@/modules/core/app/resources/BaseEntityResource';
import { GenericModel } from '@/modules/core/app/models/GenericModel';

class ClientCategoryResource extends BaseEntityResource {
  constructor() {
    super(RouteGroup.CLIENTCATEGORIES, GenericModel);
  }
}

export default new ClientCategoryResource();
